import React, { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import DemoHeader from "./DemoHeader";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import "./DemoLayout.css";
import DemoFooter from "./DemoFooter";


const DemoLayout = ({ company }) => {
  const theme = useTheme();
  const location = useLocation();

  const [isStuck, setIsStuck] = useState(false);

  function resultsView() {
    return location.pathname.includes("results");
  }

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 70) {
        setIsStuck(true);
      } else {
        setIsStuck(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup event listener on unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Media queries
  const mobile = useMediaQuery(theme.breakpoints.between("mobile", "ipad"));
  const tablet = useMediaQuery(theme.breakpoints.between("ipad", "laptop"));
  const laptop = useMediaQuery(theme.breakpoints.up("laptop"));

 
  return (
    <React.Fragment>

      {/* MOBILE */}
      {mobile && (
        <div>
          {/* Header */}
          <DemoHeader company={company}/>

          {/* Outlet */}
          <div id="m-main">
            <div className="m-main-content">
              <Outlet />
            </div>
          </div>
          {/* Footer */}
          <div id="m-footer">
            <DemoFooter />
          </div>
        </div>
      )}

      {/* TABLET */}
      {tablet && (
        <div>
          {/* Header */}
          <DemoHeader company={company}/>

          {/* Outlet */}
          <div id="t-main">
            <div className="t-main-content">
              <Outlet />
            </div>
          </div>

          {/* Footer */}
          <div id="t-footer">
            <DemoFooter />
          </div>
        </div>
      )}

      {/* LAPTOP */}
      {laptop && (
        <div id="maatwerk-container">
          {/* Header */}
          <header
            className={`d-header has-sticky sticky-jump  `}
            style={{
              height: isStuck ? "95px" : "",
            }}
          >
            <div
              id="d-header-wrapper"
              className={`d-header-wrapper ${isStuck ? "stuck" : ""}
                  ${resultsView() ? "results-header" : ""}
                  `}
            >
              <DemoHeader company={company}/>
            </div>
          </header>

          {/* Outlet */}
          <div id="d-main">
            <div
              className={`d-main-content ${
                resultsView() ? "results-page" : ""
              }`}
            >
              <Outlet />
            </div>
          </div>

          {/* Footer */}
          <div
            id="d-footer"
            className={`${resultsView() ? "results-footer" : ""}`}
          >
            <DemoFooter />
          </div>
        </div>
      )}
    </React.Fragment>
  );
};
export default DemoLayout;
